import type { ComponentStyleConfig } from '@chakra-ui/react';

const CloseButtonComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    _focus: {
      boxShadow: 'none',
    },
    _focusVisible: {
      boxShadow: 'outline',
    },
  },
};

export default CloseButtonComponentStyle;
